import React, {forwardRef, HTMLInputAutoCompleteAttribute} from "react";
import "./form.css"

export type InputProps = {
    name?: string;
    title?: string;
    type: string;
    className?: string;
    placeholder?: string;
    multiple?: boolean;
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    // @ts-ignore
    onClick?: (event: MouseEvent<HTMLButtonElement>) => void;
    autoComplete?: HTMLInputAutoCompleteAttribute;
    value?: string | number | undefined;
    errorMsg?: string;
    disabled?: boolean;
};

const Input = forwardRef((props: InputProps, ref) => {
    return (
        <div className="form__input">
            {
                props.type !== "submit" &&
                <>
                    <label htmlFor={props.name} className="form__input-label">
                        {props.title}
                    </label>
                    <div className="form__input-field">
                        <input
                            type={props.type}
                            className={props.className}
                            id={props.name}
                            multiple={props.multiple}
                            name={props.name}
                            placeholder={props.placeholder}
                            onChange={props.onChange}
                            onClick={props.onClick}
                            autoComplete={props.autoComplete}
                            value={props.value}
                            disabled={props.disabled}
                        />
                    </div>
                </>
            }
            {
                props.type === "submit" &&
                <>
                    <input
                        type={props.type}
                        className={props.className}
                        id={props.name}
                        name={props.name}
                        placeholder={props.placeholder}
                        onChange={props.onChange}
                        onClick={props.onClick}
                        autoComplete={props.autoComplete}
                        value={props.value}
                        disabled={props.disabled}
                    />
                    <div className="form__error">{props.errorMsg}</div>
                </>
            }
        </div>
    )
})

export default Input;